module.exports = __webpack_public_path__ + "media/images/fondo_header-6e4a5cdfac673d869db89f36c98b2fef.jpg";